import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=2a55ee58&scoped=true"
import script from "./delete.vue?vue&type=script&lang=js"
export * from "./delete.vue?vue&type=script&lang=js"
import style0 from "./delete.vue?vue&type=style&index=0&id=2a55ee58&prod&lang=css"
import style1 from "./delete.vue?vue&type=style&index=1&id=2a55ee58&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a55ee58",
  null
  
)

export default component.exports